import { onCleanup, onMount } from 'solid-js';
import './ui/styles.css';
import { Toasts } from './ui/Toasts';
import { SlotList } from './ui/SlotList';
import { SheetPreview } from './ui/SheetPreview';
import { Header } from './ui/Header';
import { activeView, setSelectedId } from './ui/uiState';

export function App() {
  onMount(() => {
    function onKey(e: KeyboardEvent) {
      if (e.key === 'Escape') {
        setSelectedId(null);
      }
    }
    document.addEventListener('keydown', onKey);
    onCleanup(() => document.removeEventListener('keydown', onKey));
  });

  return (
    <>
      <div class="app" data-active-view={activeView()}>
        <header class="app-header"><Header /></header>
        <aside class="app-list"><SlotList /></aside>
        <main class="app-preview"><SheetPreview /></main>
      </div>
      <Toasts />
    </>
  );
}
